import { IPrice } from '@canvas-logic/clp-domain';
import { formatPrice } from '@canvas-logic/clp-shared-ui';

export function getSelectedPriceEntry(price: IPrice, selectedCurrency?: string): [string, number] | undefined {
  if (selectedCurrency) {
    // Match the requested currency case-insensitively (e.g. ?currency=usd -> "USD" key),
    // but return the stored key so formatting uses the catalog's canonical casing.
    // When a currency is explicitly requested but has no price entry, return undefined
    // (rendered as '') rather than falling back to another currency's amount — showing a
    // different currency's number under the requested currency would be misleading.
    const target = selectedCurrency.toLowerCase();
    const matchedKey = Object.keys(price).find((key) => key.toLowerCase() === target);
    return matchedKey !== undefined ? [matchedKey, price[matchedKey]] : undefined;
  }

  // No currency requested: show whatever price exists (first available entry).
  return Object.entries(price).at(0);
}

export function formatSelectedPrice(price: IPrice, selectedCurrency: string | undefined, locale: string): string {
  const entry = getSelectedPriceEntry(price, selectedCurrency);
  if (!entry) return '';

  const [currency, amount] = entry;
  return formatPrice(amount, currency, locale);
}
